import React, { useEffect, useState } from 'react'
import {  NewBackArrowIconForEvents, EditIconBranding } from '../../utils/icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ToolTipNew } from '../AdminTeamCreation/styles';
import { EventHeading, HeadingContainer } from '../MainEvents/OnDemandDetailsPage/style';
import {  EventCard, FlexWrapper, NewChampionsCard, NewContentV2, NewVideoPlayer } from '../ChallengeCreationAdmin/styles';
import PropTypes from 'prop-types';
import { GetAllChallengesList } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import Thumbnail from '../Thumbnail';
import {ImageUrl} from '../../utils/constants';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { ChallengesContainer } from '../WellnessChallenge/styles';
// import { useParams } from "react-router-dom";


function LegacyChallengeCategoryTab(props) {
  const { history } = props;

  const [WellnessChallengeList, setWellnessChallengeList] = React.useState([]);
  const [onHover, setOnHover] = useState(-1);
  const location = useLocation();
  let categoryId =  location.state?.categoryData?.id;
  let pillarId =  location.state?.categoryData?.pillar_id;
  window.console.log("categoryId",categoryId)
  const categoryDescription = location.state?.categoryData?.category_name;


  const onEnterMouse = (id) => {
    setOnHover(id);
  };

  const onLeaveMouse = () => {
    setOnHover(-1);
  };
  

  const renderHeading = () => {
   
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {value}
        </div>
      </Popover>
    );
    
    return (
      <EventHeading style={{height:"56px"}}>
        <ToolTipNew
          margin={"auto 0px auto 15px"}
          height="40px"
          width="40px"
        >
          <OverlayTrigger placement="bottom" overlay={popover("Back")}>
            <div
              className='toolTip'
              // onClick={() => history.push(`/challenges/categories`)}
              onClick={()=>history.push({pathname: '/challenges/categories',query: {isCategory:true}})}
              style={{ background: "none" }} 
            >
              <NewBackArrowIconForEvents/> 
            </div>
          </OverlayTrigger>
        </ToolTipNew>

        <div className="title">{categoryDescription}</div>
      </EventHeading>
    );
  };

  


  useEffect(() => {
    getWellnessChallengeList();
  }, []);


  // const getWellnessChallenge = async()=>{
  //   const challenge_id = 1; 
  //   let apiUrl = GetWellnessChallenge + "/" + challenge_id ;
  //   try{
  //     const res = await fetchApi(apiUrl, "GET");
  //     window.console.log("res", res);
  //     if(res.status === "success"){
  //       setWellnessChallenge(res.data);
       
  //     }else{
  //       toast.error(res.message);
  //     }
  //   }catch(error){
  //     toast.error(error)
  //   }
  // }


  const getWellnessChallengeList = async()=>{
    // const categoryId = categoryId; 
    let apiUrl = GetAllChallengesList + "/" + pillarId ;
    try{
      const res = await fetchApi(apiUrl, "GET");
      if(res.status === "success"){
        setWellnessChallengeList(res.data);
       
      }else{
        toast.error(res.message);
      }
    }catch(error){
      toast.error(error)
    }
  }

  




  return (
    <div>
      <ChallengesContainer>
        <HeadingContainer>{renderHeading()}</HeadingContainer>
        <FlexWrapper>
          {WellnessChallengeList?.length > 0 ? WellnessChallengeList.map((item, index) => (
            <NewChampionsCard key={index}>
              <EventCard isMarginBottom={"0px"} onMouseEnter={() => onEnterMouse(index)} onMouseLeave={() => onLeaveMouse()}>
                <NewVideoPlayer>
                  <Thumbnail
                    //  onClick={()=>upComingEventsRedirection(item?.id)}
                    style={{ cursor: 'default' }}
                    src={`${ImageUrl}/${item?.image}`}
                    alt={'img'}
                  />
                </NewVideoPlayer>
                {onHover === index &&
                     <div className='educateImageBackground' onClick={() => history.push({pathname: `/company/challenges/edit-challenge/${item?.id}`, state : {category_Id: pillarId, categoryData:location?.state,  challengeName: categoryDescription}})}>
                       <div className="getStarted">
                         {EditIconBranding("#FFFFFF")}
                         {("Edit challenge")}
                       </div>
                     </div>
                }
                <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto' }}>
                  <div className='firstContainer'>
                    <div className='name' title={item?.title}>
                      {item?.title}
                    </div>
                    {/* <div className='category' title={item?.description}>
                      {item?.description}
                    </div> */}
                  </div>
                </NewContentV2>
              </EventCard>
            </NewChampionsCard> )):null }
        
        </FlexWrapper>
      </ChallengesContainer>

    </div>
  )
}



LegacyChallengeCategoryTab.propTypes = {
  history: PropTypes.object,
};

export default LegacyChallengeCategoryTab
